import { useEffect, useState, useRef } from "react";
import "../../Styles/Cart.css";
import { connect } from "react-redux";
import {
  getCartRequest,
  getsimilarproductdataRequest,
  removeCartRequest,
  insertCartRequest,
} from "../../Containers/Home/Home-slice";
import { getaddressRequest } from "../../Containers/Accounts/Account-slice";
import Loader from "../../Common/Loading";
import { useLocation, useNavigate } from "react-router-dom";
import { showSuccess, showError } from "../../utils/Toast";
import axiosInstance from "../../utils/AxiosConfig";
import dhiramsymbol from "../../assests/dhirams-png.webp";
import OfferCountdown from "../Common/OfferCountdown";
import TabbyPromo from "../Payments/TabbyPromo";
import {
  DEFAULT_PRODUCT_IMAGE,
  getDisplayPrice,
  getDisplayPricing,
  isProductOutOfStock,
  withDefaultProductImage,
} from "../../utils/productPresentation";
import { formatAED } from "../../utils/currency";
import {
  COD_MINIMUM_ORDER_MESSAGE,
  isCodAvailableForTotal,
} from "../../utils/paymentRules";
import {
  calculateDeliveryCharge,
  CART_DELIVERY_PENDING_MESSAGE,
  FREE_DELIVERY_MINIMUM,
  FREE_DELIVERY_QUALIFIED_MESSAGE,
  getAmountNeededForFreeDelivery,
} from "../../utils/deliveryRules";
import { openAuthModal } from "../../utils/authModal";
import { getBuyerToken } from "../../utils/authStorage";
import {
  addGuestCartItem,
  fetchGuestCartItems,
  removeGuestCartItem,
  updateGuestCartItem,
  GUEST_CART_EVENT,
} from "../../utils/guestCart";
import { getViewportIsMobile } from "../../utils/browser";




function Cart({
  getcartRequest,
  cartPayload,
  cartData,
  removeCart,
  removecartdata,
  cartLoading,
  getsimilarproductdataRequest,
  similarproductdata,
  insertCartRequest,
  addcartdata,
  getaddressRequest,
  getaddressData,
}) {
  const [cartItems, setCartItems] = useState([]);
  const similarProductsRef = useRef(null);
  const stockToastSignatureRef = useRef("");
  const offerUpdateToastSignatureRef = useRef("");
  const hasMountedAddCartToastRef = useRef(false);
  const hasMountedRemoveCartToastRef = useRef(false);
  const [tempQuantities, setTempQuantities] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [isUpdatingCartId, setIsUpdatingCartId] = useState(null);
  const suppressDrawerNavigationToastRef = useRef(false);
  const expiredOfferRefreshKeysRef = useRef(new Set());
  const offerRefreshInFlightRef = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check screen size for mobile
  useEffect(() => {
    setIsMobile(getViewportIsMobile());

    const handleResize = () => {
      setIsMobile(getViewportIsMobile());
    };
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    suppressDrawerNavigationToastRef.current = Boolean(
      location.state?.suppressCartMutationToasts,
    );
  }, [location.state]);

  useEffect(() => {
    if (getBuyerToken()) {
      getaddressRequest();
    }
  }, [getaddressRequest]);

  useEffect(() => {
    if (!hasMountedAddCartToastRef.current) {
      hasMountedAddCartToastRef.current = true;
      return;
    }

    if (!addcartdata) return;
    if (addcartdata.success) {
      if (suppressDrawerNavigationToastRef.current) {
        getcartRequest();
        return;
      }

      showSuccess(addcartdata.message);
      getcartRequest();
      window.scrollTo(0, 0);
    }
  }, [addcartdata, getcartRequest]);

  function numberWithCommas(x) {
    if (x == null || Number.isNaN(Number(x))) return "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const normalizeStock = (stock) => {
    const parsed = Number(stock);
    if (!Number.isFinite(parsed)) return 0;
    return Math.max(0, Math.floor(parsed));
  };

  const normalizeQuantityValue = (quantity) => {
    const parsed = Number.parseInt(quantity, 10);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : 1;
  };

  const getMaxStock = (item) => normalizeStock(item?.totalStock);
  const getSafeQuantityForItem = (item, quantity) => {
    const normalizedQuantity = normalizeQuantityValue(quantity);
    const maxStock = getMaxStock(item);

    if (maxStock <= 0) {
      return normalizedQuantity;
    }

    return Math.min(normalizedQuantity, maxStock);
  };

  const mapCartApiItems = (items = []) =>
    items.map((it) => {
      const pricing = getDisplayPricing(it);
      const price = pricing.originalPrice || getDisplayPrice(it);
      const discount = pricing.discountPercent;
      const discountAmount = pricing.discountAmount;
      const finalPrice = pricing.finalPrice || price - discountAmount;
      const offerEndAt =
        it.offer_end_at ??
        it.offerEndAt ??
        it.to_date ??
        it.toDate ??
        null;
      const isOfferActive =
        it.is_offer_active === false || it.isOfferActive === false
          ? false
          : Boolean((it.is_offer_active ?? it.isOfferActive ?? pricing.hasOffer) && offerEndAt);

      const availableQty = Number(
        it.available_quantity ??
          it.Available_Qty ??
          it.available_qty ??
          it.totalStock ??
          it.stock_quantity ??
          it.stock ??
          it.inventory ??
          0,
      );

      return {
        id: it.id,
        product_id: it.product_id,
        product_name: it.product_name,
        product_image: withDefaultProductImage(it.product_image || it.image_url),
        price,
        finalPrice,
        discount,
        discountAmount,
        hasOfferPricing: Boolean(pricing.hasOffer && isOfferActive),
        offer_id: pricing.offerId,
        offer_title: pricing.offerTitle,
        offer_message: pricing.offerMessage,
        original_price: it.original_price ?? price,
        offer_price: it.offer_price ?? finalPrice,
        offer_discount_amount: it.offer_discount_amount ?? discountAmount,
        offer_end_at: offerEndAt,
        is_offer_active: isOfferActive,
        quantity: normalizeQuantityValue(it.quantity),
        totalStock: normalizeStock(availableQty),
        available_quantity: normalizeStock(availableQty),
        attributes: it.attributes || null,
        product_status: it.product_status,
        approval_status: it.approval_status,
        is_out_of_stock: Boolean(it.is_out_of_stock),
        stockErrorMessage: String(it.stock_error_message || "").trim(),
      };
    });

  const syncCartItems = (items = []) => {
    const mapped = mapCartApiItems(items);
    setCartItems(mapped);

    const initialTemp = {};
    mapped.forEach((item) => {
      initialTemp[item.id] = normalizeQuantityValue(item.quantity).toString();
    });
    setTempQuantities(initialTemp);

    return mapped;
  };

  const getCartItemStockMessage = (item) => {
    if (!item) return "";

    if (isProductOutOfStock(item)) {
      return item.stockErrorMessage || "This product is currently out of stock.";
    }

    const maxStock = getMaxStock(item);
    if (item.quantity > maxStock) {
      return `Only ${maxStock} quantity available. Please update quantity.`;
    }

    return "";
  };

  const validateCartStockState = (items = []) => {
    const invalidQuantityItem = items.find(
      (item) => !item.quantity || item.quantity <= 0 || Number.isNaN(item.quantity),
    );
    if (invalidQuantityItem) {
      return {
        isValid: false,
        message: `Please enter valid quantity for ${invalidQuantityItem.product_name}`,
      };
    }

    if (items.some((item) => isProductOutOfStock(item))) {
      return {
        isValid: false,
        message: "Some products in your cart are out of stock. Please update your cart.",
      };
    }

    if (items.some((item) => item.quantity > getMaxStock(item))) {
      return {
        isValid: false,
        message: "Some cart quantities exceed available stock. Please update your cart.",
      };
    }

    return { isValid: true, message: "" };
  };

  const notifyCartOfferUpdates = (payload) => {
    if (!payload?.offer_updates_applied || !payload?.message) {
      offerUpdateToastSignatureRef.current = "";
      return;
    }

    const signature = [
      payload.message,
      Array.isArray(payload.data)
        ? payload.data.map((item) => `${item.id}:${item.offer_id || 0}`).join("|")
        : "",
    ].join("::");

    if (offerUpdateToastSignatureRef.current === signature) {
      return;
    }

    offerUpdateToastSignatureRef.current = signature;
    showError(payload.message);
  };

  const handleOfferCountdownExpire = async (item) => {
    const refreshKey = `${item?.id || item?.product_id}:${item?.offer_id || 0}:${item?.offer_end_at || ""}`;

    if (
      !refreshKey ||
      expiredOfferRefreshKeysRef.current.has(refreshKey) ||
      offerRefreshInFlightRef.current
    ) {
      return;
    }

    expiredOfferRefreshKeysRef.current.add(refreshKey);
    offerRefreshInFlightRef.current = true;

    try {
      await fetchLatestCartItems();
    } catch {
      // Keep the existing cart state if the validation refresh fails.
    } finally {
      offerRefreshInFlightRef.current = false;
    }
  };

  const fetchLatestCartItems = async () => {
    if (!getBuyerToken()) {
      const guestCart = await fetchGuestCartItems();
      if (guestCart.missing.length) {
        showError("Some cart items are no longer available and were removed.");
      }
      return syncCartItems(guestCart.items);
    }

    const response = await axiosInstance.get("getCart");
    notifyCartOfferUpdates(response.data);
    const latestItems = Array.isArray(response.data?.data) ? response.data.data : [];
    return syncCartItems(latestItems);
  };

  useEffect(() => {
    getcartRequest();
  }, [getcartRequest]);

  useEffect(() => {
    const refreshGuestCart = () => {
      if (!getBuyerToken()) {
        setCartItems([]);
        setTempQuantities({});
        getcartRequest();
      }
    };

    window.addEventListener(GUEST_CART_EVENT, refreshGuestCart);
    window.addEventListener("storage", refreshGuestCart);
    return () => {
      window.removeEventListener(GUEST_CART_EVENT, refreshGuestCart);
      window.removeEventListener("storage", refreshGuestCart);
    };
  }, [getcartRequest]);

  useEffect(() => {
    if (!hasMountedRemoveCartToastRef.current) {
      hasMountedRemoveCartToastRef.current = true;
      return;
    }

    if (!removecartdata) return;
    if (removecartdata?.success) {
      if (suppressDrawerNavigationToastRef.current) {
        getcartRequest();
        return;
      }

      showSuccess(removecartdata.message);
      getcartRequest();
    }
  }, [removecartdata, getcartRequest]);

  useEffect(() => {
    if (!cartData) return;
    if (!getBuyerToken() && cartPayload?.source !== "guest") return;
    syncCartItems(cartData);
    // syncCartItems is intentionally kept local so cart data can be normalized in one place.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, cartPayload]);

  useEffect(() => {
    notifyCartOfferUpdates(cartPayload);
    // The toast should follow the raw cart payload so offer expiry updates are shown once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartPayload]);

  useEffect(() => {
    const validation = validateCartStockState(cartItems);
    const signature = validation.isValid ? "" : validation.message;

    if (!signature) {
      stockToastSignatureRef.current = "";
      return;
    }

    if (stockToastSignatureRef.current === signature) {
      return;
    }

    stockToastSignatureRef.current = signature;
    showError(signature);
    // validateCartStockState is intentionally kept local so stock blocking stays aligned with cart rendering.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems]);

  useEffect(() => {
    if (!cartData) return;
    if (cartData.length !== 0) {
      getsimilarproductdataRequest(cartData[0].product_id);
    }
  }, [cartData, getsimilarproductdataRequest]);

  const updateQuantity = (id, qty) => {
    const safeQty = Math.max(1, Math.floor(Number(qty) || 1));

    setCartItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, quantity: safeQty } : it)),
    );

    setTempQuantities((prev) => ({
      ...prev,
      [id]: safeQty.toString(),
    }));
  };

  if (cartLoading) {
    return <Loader />;
  }

  const onRemove = (id) => {
    suppressDrawerNavigationToastRef.current = false;
    setCartItems((prev) => prev.filter((it) => it.id !== id));
    setTempQuantities((prev) => {
      const newTemp = { ...prev };
      delete newTemp[id];
      return newTemp;
    });
    const item = cartItems.find((cartItem) => cartItem.id === id);
    if (!getBuyerToken()) {
      removeGuestCartItem(item);
      showSuccess("Cart item removed");
      getcartRequest();
      return;
    }

    removeCart(id);
  };

  // Calculate order totals without VAT
  const subtotalExcludingVAT = cartItems.reduce(
    (total, item) => total + item.finalPrice * (item.quantity || 0),
    0,
  );
  const totalDiscountAmount = cartItems.reduce(
    (total, item) => total + item.discountAmount * (item.quantity || 0),
    0,
  );

  const totalAmount = subtotalExcludingVAT;
  const originalPriceTotal = cartItems.reduce(
    (total, item) => total + item.price * (item.quantity || 0),
    0,
  );
  const savedAddresses = Array.isArray(getaddressData?.data)
    ? getaddressData.data.filter(
        (addr) => addr?.address && String(addr.address).trim() !== "",
      )
    : [];
  const defaultSavedAddress =
    savedAddresses.find(
      (addr) => Number(addr?.is_default_address || 0) === 1,
    ) || null;
  const deliveryCharge = calculateDeliveryCharge({
    subtotal: subtotalExcludingVAT,
    emirate: defaultSavedAddress?.state,
  });
  const hasQualifiedForFreeDelivery =
    subtotalExcludingVAT >= FREE_DELIVERY_MINIMUM;
  const amountNeededForFreeDelivery = getAmountNeededForFreeDelivery(
    subtotalExcludingVAT,
  );
  const cartPayableTotal =
    deliveryCharge === null ? null : totalAmount + deliveryCharge;
  const deliverySummaryMessage =
    cartItems.length === 0
      ? ""
      : hasQualifiedForFreeDelivery
        ? FREE_DELIVERY_QUALIFIED_MESSAGE
        : deliveryCharge === null
          ? CART_DELIVERY_PENDING_MESSAGE
          : `Add ${formatAED(amountNeededForFreeDelivery)} more to get free delivery.`;
  const isCodEligibleForCartTotal = isCodAvailableForTotal(
    cartPayableTotal ?? totalAmount,
  );

  const fmt = (price) => {
    if (typeof price === "number") {
      return `${price.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
    return `${price}`;
  };

  const onclickcart = (data) => {
    suppressDrawerNavigationToastRef.current = false;

    if (isProductOutOfStock(data)) {
      showError("This product is currently out of stock.");
      return;
    }

    const pricingDetails = getDisplayPricing(data);
    const payload = {
      product_id: data?.id ?? data?.product_id,
      quantity: data?.quantity ? Number(data.quantity) : 1,
      price: Number(getDisplayPrice(data) ?? 0),
      discount: Number(data?.discount ?? 0),
      attributes: data.attributes,
    };
    if (pricingDetails.hasOffer) {
      payload.offer_id = pricingDetails.offerId;
    }

    if (!getBuyerToken()) {
      addGuestCartItem(payload);
      showSuccess("Cart Added Successfully");
      getcartRequest();
      return;
    }

    insertCartRequest(payload);
  };

  const SimpleProductCard = ({ product }) => {
    const imageUrl = product.singleImage || product.image_url;
    const pricingDetails = getDisplayPricing(product);
    const discount = parseFloat(product.discount) || 0;
    const oldPrice =
      pricingDetails.hasOffer || discount > 0 ? pricingDetails.originalPrice : null;
    const currentPrice = pricingDetails.finalPrice;
    const formatPrice = (value) => numberWithCommas(Number(value).toFixed(2));
    const outOfStock = isProductOutOfStock(product);

    return (
      <article className="ds-product-card ds-product-card-hover cart-suggest-card">
        <div className="ds-product-card-media cart-suggest-card__media">
          {outOfStock && (
            <div className="pcard-badge-orange">Out of Stock</div>
          )}
          {pricingDetails.hasOffer ? (
            <div className="ds-product-card-badge">
              Save AED {formatPrice(pricingDetails.discountAmount)}
            </div>
          ) : discount > 0 ? (
            <div className="ds-product-card-badge">{discount}% OFF</div>
          ) : null}
          <img
            src={withDefaultProductImage(imageUrl)}
            alt={product.name}
            onError={(event) => {
              event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
            }}
          />
        </div>

        <div className="cart-suggest-card__body">
          <p className="ds-product-card-name cart-suggest-card__name">
            {product.name}
          </p>

          <div className="ds-product-card-prices cart-suggest-card__prices">
            <span className="ds-product-card-price cart-suggest-card__price">
              <img
                src={dhiramsymbol}
                width={18}
                height={18}
                alt="Dirham"
                className="cart-suggest-card__currency"
              />
              <span>{formatPrice(currentPrice)}</span>
            </span>
            {oldPrice && (
              <span className="ds-product-card-old-price cart-suggest-card__old-price">
                {formatPrice(oldPrice)}
              </span>
            )}
          </div>

          <button
            type="button"
            className="ds-product-card-btn cart-suggest-card__btn"
            disabled={outOfStock}
            style={outOfStock ? { opacity: 0.7, cursor: "not-allowed" } : undefined}
            onClick={(e) => {
              e.stopPropagation();
              onclickcart(product);
            }}
          >
            {outOfStock ? "Out of Stock" : "Add to Cart"}
          </button>
        </div>
      </article>
    );
  };

  const persistCartQuantity = async (item, quantity) => {
    setIsUpdatingCartId(item.id);

    if (!getBuyerToken()) {
      updateGuestCartItem(item, quantity);
      try {
        const guestCart = await fetchGuestCartItems();
        syncCartItems(guestCart.items);
        return true;
      } catch {
        showError("Failed to update cart quantity");
        return false;
      } finally {
        setIsUpdatingCartId(null);
      }
    }

    try {
      const response = await axiosInstance.post("updateCart", {
        id: item.id,
        cart_id: item.id,
        quantity,
      });

      if (!response.data?.success) {
        showError(
          response.data?.stock_error_message ||
            response.data?.message ||
            "Failed to update cart quantity",
        );
        await fetchLatestCartItems();
        return false;
      }

      await fetchLatestCartItems();
      return true;
    } catch (error) {
      showError(
        error?.response?.data?.stock_error_message ||
          error?.response?.data?.message ||
          "Failed to update cart quantity",
      );
      try {
        await fetchLatestCartItems();
      } catch {
        // Keep the current UI state if the refresh fails after showing the error.
      }
      return false;
    } finally {
      setIsUpdatingCartId(null);
    }
  };

  const handleCheckout = async () => {
    if (isUpdatingCartId !== null) {
      showError("Please wait for the cart update to finish.");
      return;
    }

    if (cartItems.length === 0) {
      showError("Your cart is empty. Please add items to proceed.");
      return;
    }

    if (!getBuyerToken()) {
      openAuthModal({ returnTo: "/checkout" });
      return;
    }

    let latestItems = cartItems;
    try {
      latestItems = await fetchLatestCartItems();
    } catch (error) {
      showError("Unable to validate your cart right now. Please try again.");
      return;
    }

    const validation = validateCartStockState(latestItems);
    if (!validation.isValid) {
      showError(validation.message);
      return;
    }

    const productIds = latestItems.map((item) => item.product_id);
    const productIdsString = productIds.join(",");
    const latestSubtotal = latestItems.reduce(
      (sum, item) => sum + item.finalPrice * (item.quantity || 0),
      0,
    );
    const latestTotalAmount = latestSubtotal;

    const checkoutItems = latestItems.map((item) => ({
      product_id: item.product_id,
      product_name: item.product_name,
      quantity: item.quantity,
      price: item.price,
      finalPrice: item.finalPrice,
      discount: item.discount,
      discountAmount: item.discountAmount,
      offer_id: item.offer_id,
      original_price: item.original_price,
      offer_price: item.offer_price,
      offer_discount_amount: item.offer_discount_amount,
      totalStock: item.totalStock,
      attributes: item.attributes,
      product_image: item.product_image,
    }));

    navigate("/checkout", {
      state: {
        totalAmount: latestTotalAmount,
        id: latestItems[0].product_id,
        productIdsString,
        cartItems: checkoutItems,
        totalQuantity: latestItems.reduce((sum, item) => sum + item.quantity, 0),
      },
    });
  };

  const handleQuantityInput = (id, value) => {
    const item = cartItems.find((it) => it.id === id);
    if (!item) return;

    setTempQuantities((prev) => ({
      ...prev,
      [id]: value,
    }));

    if (value !== "" && !isNaN(value) && parseInt(value, 10) > 0) {
      const numValue = parseInt(value, 10);
      const maxStock = getMaxStock(item);

      if (maxStock > 0 && numValue <= maxStock) {
        updateQuantity(id, numValue);
      }
    }
  };

  const handleQuantityKeyDown = (e, id) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  const handleQuantityBlur = async (id) => {
    if (isUpdatingCartId === id) return;

    const item = cartItems.find((it) => it.id === id);
    if (!item) return;

    const tempValue = tempQuantities[id];
    const maxStock = getMaxStock(item);
    const currentQty = normalizeQuantityValue(item.quantity);
    const fallbackQty = getSafeQuantityForItem(item, currentQty);

    if (!tempValue || tempValue === "") {
      showError("Quantity must be at least 1");
      setTempQuantities((prev) => ({
        ...prev,
        [id]: fallbackQty.toString(),
      }));
      updateQuantity(id, fallbackQty);
      return;
    }

    const newQty = parseInt(tempValue, 10);

    if (isNaN(newQty) || newQty < 1) {
      showError("Quantity must be at least 1");
      setTempQuantities((prev) => ({
        ...prev,
        [id]: fallbackQty.toString(),
      }));
      updateQuantity(id, fallbackQty);
      return;
    }

    if (isProductOutOfStock(item) || maxStock <= 0) {
      showError(getCartItemStockMessage(item));
      setTempQuantities((prev) => ({
        ...prev,
        [id]: currentQty.toString(),
      }));
      return;
    }

    if (newQty > maxStock) {
      showError(`Only ${maxStock} quantity available. Please update quantity.`);
      setTempQuantities((prev) => ({
        ...prev,
        [id]: currentQty.toString(),
      }));
      return;
    }

    updateQuantity(id, newQty);
    if (newQty !== currentQty) {
      await persistCartQuantity(item, newQty);
    }
  };

  const handleQtyStep = async (id, delta) => {
    if (isUpdatingCartId === id) return;

    const item = cartItems.find((it) => it.id === id);
    if (!item) return;

    const maxStock = getMaxStock(item);
    const currentQty = normalizeQuantityValue(item.quantity);
    const nextQty = currentQty + delta;

    if (nextQty < 1) return;

    if (delta > 0 && (maxStock <= 0 || currentQty >= maxStock)) {
      showError(
        maxStock <= 0
          ? getCartItemStockMessage(item)
          : `Only ${maxStock} quantity available. Please update quantity.`,
      );
      setTempQuantities((prev) => ({
        ...prev,
        [id]: currentQty.toString(),
      }));
      return;
    }

    updateQuantity(id, nextQty);
    await persistCartQuantity(item, nextQty);
  };

  const isValidQuantity = (qty) => {
    return qty && qty > 0 && !isNaN(qty);
  };

  const hasInvalidQuantity = cartItems.some(
    (item) => !isValidQuantity(item.quantity),
  );
  const hasOutOfStockItems = cartItems.some((item) => isProductOutOfStock(item));
  const hasStockIssue = cartItems.some(
    (item) => item.quantity > getMaxStock(item),
  );
  const cartBlockMessage = hasOutOfStockItems
    ? "Some products in your cart are out of stock. Please update your cart."
    : hasStockIssue
      ? "Some cart quantities exceed available stock. Please update your cart."
      : "";
  const canCheckout =
    cartItems.length > 0 &&
    !hasInvalidQuantity &&
    !hasStockIssue &&
    !hasOutOfStockItems;

  // Mobile Cart Item Component
  const MobileCartItem = ({ it }) => {
    const maxStock = getMaxStock(it);
    const outOfStock = isProductOutOfStock(it);
    const tempValue = tempQuantities[it.id];
    const tempNumber =
      tempValue !== "" && tempValue !== undefined
        ? parseInt(tempValue, 10)
        : null;
    const isTempOverStock = Number.isFinite(tempNumber) && tempNumber > maxStock;
    const isOverStock = it.quantity > maxStock;
    const showStockWarning = outOfStock || isOverStock || isTempOverStock;

    return (
      <div className={`cart-item-box-mobile ${showStockWarning ? "cart-item-out" : ""}`}>
        <div className="cart-item-info-mobile">
          <img
            src={it.product_image}
            alt={it.product_name}
            className="cart-item-image-mobile"
            onError={(event) => {
              event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
            }}
          />
          <div className="cart-item-texts-mobile">
            <div className="cart-item-title-mobile">{it.product_name}</div>
            {it.hasOfferPricing ? (
              <div className="cart-item-discount-mobile">
                Save {formatAED(it.discountAmount)}
              </div>
            ) : it.discount > 0 ? (
              <div className="cart-item-discount-mobile">{it.discount}% OFF</div>
            ) : null}
            {it.hasOfferPricing && it.offer_title ? (
              <div className="cart-item-details-mobile">
                <span className="cart-item-stock-mobile">{it.offer_title}</span>
              </div>
            ) : null}
            {outOfStock ? (
              <div className="cart-item-discount-mobile" style={{ color: "#b91c1c" }}>
                Out of Stock
              </div>
            ) : null}
            <div className="cart-item-details-mobile">
              <span className="cart-item-stock-mobile">
                {outOfStock ? "Currently unavailable" : `Stock: ${maxStock} available`}
              </span>
            </div>
          </div>
        </div>

        <div className="cart-item-price-mobile">
          <span className="price-label">Unit Price:</span>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
            {it.hasOfferPricing ? (
              <>
                <span style={{ color: "#6b7280", fontSize: "12px", textDecoration: "line-through" }}>
                  {formatAED(it.price)}
                </span>
                <span className="unit-price-mobile" style={{ fontWeight: "700" }}>
                  {formatAED(it.finalPrice)}
                </span>
              </>
            ) : (
              <>
                {it.discount > 0 && (
                  <span style={{ color: "#6b7280", fontSize: "12px", textDecoration: "line-through" }}>
                    {fmt(it.price)}
                  </span>
                )}
                <span className="unit-price-mobile">
                  <img src={dhiramsymbol} alt="dhiram" width={18} height={18} />
                  <span>{fmt(it.finalPrice)}</span>
                </span>
              </>
            )}
            {it.is_offer_active && it.offer_end_at ? (
              <span style={{ color: "#6b7280", fontSize: "12px", lineHeight: 1.4, textAlign: "right" }}>
                <OfferCountdown
                  endTime={it.offer_end_at}
                  fallbackText=""
                  expiredText="Offer expired"
                  showZeroDays
                  onExpire={() => handleOfferCountdownExpire(it)}
                />
              </span>
            ) : null}
          </div>
        </div>

        <div className="cart-item-qty-mobile">
          <span className="qty-label">Quantity:</span>
          <div className="cart-qty-control-mobile">
            <button
              type="button"
              className="qty-step-btn-mobile"
              onClick={() => handleQtyStep(it.id, -1)}
              disabled={
                isUpdatingCartId === it.id ||
                !isValidQuantity(it.quantity) ||
                it.quantity <= 1
              }
            >
              -
            </button>
            <input
              type="number"
              min="1"
              max={maxStock}
              value={
                tempQuantities[it.id] !== undefined
                  ? tempQuantities[it.id]
                  : normalizeQuantityValue(it.quantity).toString()
              }
              onChange={(e) => handleQuantityInput(it.id, e.target.value)}
              onBlur={() => handleQuantityBlur(it.id)}
              onKeyDown={(e) => handleQuantityKeyDown(e, it.id)}
              className="cart-item-qty-input-mobile"
              disabled={isUpdatingCartId === it.id}
            />
            <button
              type="button"
              className="qty-step-btn-mobile"
              onClick={() => handleQtyStep(it.id, 1)}
              disabled={
                isUpdatingCartId === it.id ||
                !isValidQuantity(it.quantity) ||
                maxStock <= 0 ||
                it.quantity >= maxStock
              }
            >
              +
            </button>
          </div>
          {!isValidQuantity(it.quantity) && (
            <div className="cart-qty-message-mobile cart-qty-error">Required</div>
          )}
          {showStockWarning && isValidQuantity(it.quantity) && (
            <div className="cart-qty-message-mobile cart-qty-warning">
              {isTempOverStock && !outOfStock
                ? `Only ${maxStock} quantity available. Please update quantity.`
                : getCartItemStockMessage(it)}
            </div>
          )}
        </div>

        <div className="cart-item-total-mobile">
          <span className="total-label">Total:</span>
          <span className="total-price-mobile">
            {isValidQuantity(it.quantity) ? fmt(it.finalPrice * it.quantity) : "AED 0.00"}
          </span>
        </div>

        <button className="remove-btn-mobile" onClick={() => onRemove(it.id)}>
          Remove Item
        </button>
      </div>
    );
  };

  // Price Summary Component (reusable)
  const PriceSummary = () => (
    <div className="price-summary">
      <h3 className="price-summary-title">Price Details</h3>

      <div className="price-row">
        <span>Original Price</span>
        <span>{fmt(originalPriceTotal)}</span>
      </div>
      {totalDiscountAmount > 0 && (
        <div className="price-row discount-row">
          <span>Discount</span>
          <span style={{ color: "#16a34a", fontWeight: "600" }}>
            -{fmt(totalDiscountAmount)}
          </span>
        </div>
      )}

      <div className="price-row">
        <span>Subtotal</span>
        <span>{fmt(subtotalExcludingVAT)}</span>
      </div>

      <div className="price-row shipping-row">
        <span>Delivery Charge</span>
        {deliveryCharge === null ? (
          <span className="summary-status-text">Calculated at checkout</span>
        ) : deliveryCharge === 0 ? (
          <span className="free-shipping">FREE</span>
        ) : (
          <span>{fmt(deliveryCharge)}</span>
        )}
      </div>

      {deliverySummaryMessage && (
        <div
          className={`shipping-note ${
            hasQualifiedForFreeDelivery ? "shipping-note-success" : ""
          }`}
        >
          {deliverySummaryMessage}
        </div>
      )}

      <div className="price-total-row">
        <span>Total Amount To pay</span>
        {cartPayableTotal === null ? (
          <span className="summary-status-text">Calculated at checkout</span>
        ) : (
          <span className="total-amount">{fmt(cartPayableTotal)}</span>
        )}
      </div>

      {cartItems.length > 0 && (
        <TabbyPromo price={cartPayableTotal ?? subtotalExcludingVAT} source="cart" />
      )}

      {cartItems.length > 0 && !isCodEligibleForCartTotal && (
        <div className="checkout-stock-warning">
          {COD_MINIMUM_ORDER_MESSAGE}
        </div>
      )}
      
      {cartBlockMessage && (
        <div className="checkout-stock-warning">
          {cartBlockMessage}
        </div>
      )}
      
      <button
        className="checkout-btn"
        onClick={handleCheckout}
        disabled={!canCheckout}
      >
        Checkout →
      </button>
    </div>
  );

  return (
    <div className="cart-page">
      <div className="cart-header">
        <div className="cart-breadcrumb-row">
          <div
            className="cart-breadcrumbs"
            style={{ color: "black", cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            Home
          </div>
          <div>› My Cart</div>
        </div>

        <h1 className="cart-heading">My Shopping Cart</h1>
      </div>

      {cartBlockMessage && (
        <div className="cart-stock-banner">
          {cartBlockMessage}
        </div>
      )}

      <div className="cart-grid">
        <div className="cart-left-column">
          <div className="cart-left">
            {isMobile && !cartLoading && cartItems.length === 0 && (
              <div className="cart-mobile-empty">
                <h2>Your cart is empty</h2>
                <button type="button" onClick={() => navigate("/")}>Continue shopping</button>
              </div>
            )}
            {/* Desktop Table Header */}
            {!isMobile && (
              <div className="cart-table-header">
                <div className="header-date">Item</div>
                <div className="header-unit">Unit Price</div>
                <div className="header-qty">Quantity</div>
                <div className="header-total">Total</div>
              </div>
            )}

            {/* Cart Items - Desktop or Mobile */}
            {isMobile ? (
              <div className="cart-items-mobile">
                {cartItems.map((it) => (
                  <MobileCartItem key={it.id} it={it} />
                ))}
              </div>
            ) : (
              cartItems.map((it) => {
                const maxStock = getMaxStock(it);
                const tempValue = tempQuantities[it.id];
                const tempNumber =
                  tempValue !== "" && tempValue !== undefined
                    ? parseInt(tempValue, 10)
                    : null;
                const outOfStock = isProductOutOfStock(it);
                const isTempOverStock =
                  Number.isFinite(tempNumber) && tempNumber > maxStock;
                const isOverStock = it.quantity > maxStock;
                const showStockWarning = outOfStock || isOverStock || isTempOverStock;

                return (
                  <div
                    key={it.id}
                    className={`cart-item-box ${
                      showStockWarning ? "cart-item-out" : ""
                    }`}
                  >
                    <div className="cart-item-info">
                      <img
                        src={it.product_image}
                        alt={it.product_name}
                        className="cart-item-image"
                        onError={(event) => {
                          event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
                        }}
                      />
                      <div className="cart-item-texts">
                        <div className="cart-item-title">{it.product_name}</div>
                        {it.hasOfferPricing ? (
                          <div className="cart-item-discount">
                            Save {formatAED(it.discountAmount)}
                          </div>
                        ) : it.discount > 0 ? (
                          <div className="cart-item-discount">{it.discount}% OFF</div>
                        ) : null}
                        {it.hasOfferPricing && it.offer_title ? (
                          <div className="cart-item-details">
                            <span className="cart-item-stock">{it.offer_title}</span>
                          </div>
                        ) : null}
                        {outOfStock ? (
                          <div className="cart-item-discount" style={{ color: "#b91c1c" }}>
                            Out of Stock
                          </div>
                        ) : null}
                        <div className="cart-item-details">
                          <span className="cart-item-stock">
                            {outOfStock ? "Currently unavailable" : `Stock: ${maxStock} available`}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="cart-item-price-col">
                      <div className="unit-price" style={{ flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                        {it.hasOfferPricing ? (
                          <>
                            <span style={{ color: "#6b7280", fontSize: "12px", textDecoration: "line-through" }}>
                              {formatAED(it.price)}
                            </span>
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", fontWeight: "700" }}>
                              <span>{formatAED(it.finalPrice)}</span>
                            </div>
                          </>
                        ) : (
                          <>
                            {it.discount > 0 && (
                              <span style={{ color: "#6b7280", fontSize: "12px", textDecoration: "line-through" }}>
                                {fmt(it.price)}
                              </span>
                            )}
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                              <img
                                src={dhiramsymbol}
                                alt="dhiram symbol"
                                width={20}
                                height={20}
                              />
                              <span>{fmt(it.finalPrice)}</span>
                            </div>
                          </>
                        )}
                        {it.is_offer_active && it.offer_end_at ? (
                          <span style={{ color: "#6b7280", fontSize: "12px", lineHeight: 1.4 }}>
                            <OfferCountdown
                              endTime={it.offer_end_at}
                              fallbackText=""
                              expiredText="Offer expired"
                              showZeroDays
                              onExpire={() => handleOfferCountdownExpire(it)}
                            />
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="cart-item-qty-col">
                      <div className="cart-qty-control">
                        <button
                          type="button"
                          className="qty-step-btn"
                          onClick={() => handleQtyStep(it.id, -1)}
                          disabled={
                            isUpdatingCartId === it.id ||
                            !isValidQuantity(it.quantity) || it.quantity <= 1
                          }
                        >
                          -
                        </button>
                        <input
                          type="number"
                          min="1"
                          max={maxStock}
                          placeholder="Enter qty"
                          value={
                            tempQuantities[it.id] !== undefined
                              ? tempQuantities[it.id]
                              : normalizeQuantityValue(it.quantity).toString()
                          }
                          onChange={(e) => handleQuantityInput(it.id, e.target.value)}
                          onBlur={() => handleQuantityBlur(it.id)}
                          onKeyDown={(e) => handleQuantityKeyDown(e, it.id)}
                          className="cart-item-qty-input"
                          disabled={isUpdatingCartId === it.id}
                        />
                        <button
                          type="button"
                          className="qty-step-btn"
                          onClick={() => handleQtyStep(it.id, 1)}
                          disabled={
                            isUpdatingCartId === it.id ||
                            !isValidQuantity(it.quantity) ||
                            maxStock <= 0 ||
                            it.quantity >= maxStock
                          }
                        >
                          +
                        </button>
                      </div>
                      {!isValidQuantity(it.quantity) && (
                        <div className="cart-qty-message cart-qty-error">
                          Required
                        </div>
                      )}
                      {showStockWarning && isValidQuantity(it.quantity) && (
                        <div className="cart-qty-message cart-qty-warning">
                          {isTempOverStock && !outOfStock
                            ? `Only ${maxStock} quantity available. Please update quantity.`
                            : getCartItemStockMessage(it)}
                        </div>
                      )}
                    </div>

                    <div className="cart-item-total-col">
                      <div className="total-price">
                        {isValidQuantity(it.quantity)
                          ? fmt(it.finalPrice * it.quantity)
                          : "AED 0.00"}
                      </div>
                      <div>
                        <button
                          className="remove-btn"
                          onClick={() => onRemove(it.id)}
                        >
                          X Remove
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Coupons Section */}
          <div className="coupons-section cart-coupons-card" style={isMobile && cartItems.length === 0 ? { display: "none" } : undefined}>
            <h4 className="coupons-title">Coupons</h4>
            <p className="coupons-note">
              You can apply coupons on the next page.
            </p>
            <div className="coupon-promo">
              Use <strong>GETROOF</strong> & Get Flat 10% Off upto AED 30 t&c
            </div>
          </div>

          {/* Price Summary - Bottom on Mobile, Right Side on Desktop */}
          {isMobile && cartItems.length > 0 && (
            <div className="cart-price-summary-mobile">
              <PriceSummary />
            </div>
          )}
        </div>

        {/* Desktop Price Summary - Right Column */}
        {!isMobile && (
          <aside className="cart-right">
            <PriceSummary />
          </aside>
        )}
      </div>

      <section className="suggested-section">
        <h2 className="suggested-title">You might also like</h2>
        <div className="sp-scroll-container" ref={similarProductsRef}>
          <div className="sp-products-row">
            {similarproductdata && similarproductdata.length > 0
              ? similarproductdata.map((product) => (
                  <SimpleProductCard key={product.id} product={product} />
                ))
              : null}
          </div>
        </div>
      </section>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    cartPayload: state.Home.getCartdata,
    cartData: state.Home.getCartdata?.data,
    removecartdata: state.Home.removecart,
    cartLoading: state.Home.getCartLoading,
    similarproductdata: state.Home.getsimilarproductdata?.data,
    addcartdata: state.Home.Cartdata,
    getaddressData: state.Account.getaddressData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getcartRequest: () => dispatch(getCartRequest()),
    removeCart: (data) => dispatch(removeCartRequest(data)),
    getsimilarproductdataRequest: (data) =>
      dispatch(getsimilarproductdataRequest(data)),
    insertCartRequest: (data) => dispatch(insertCartRequest(data)),
    getaddressRequest: () => dispatch(getaddressRequest()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
